function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#5e5e5d}\n        "));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_168",
  "data-name": "Path 168",
  className: "cls-2",
  d: "M34 13.85h-2.19v-2.22a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 .95h3.18a7.07 7.07 0 0 0 12.46 0h9.21a1 1 0 0 0 1-.95v-2.17H34a1 1 0 0 0 1-.95V14.8a1 1 0 0 0-1-.95zM15.41 27.07a5.79 5.79 0 1 1 5.78-5.78 5.79 5.79 0 0 1-5.78 5.78zm15.12-3.71h-8.36a7.07 7.07 0 1 0-13.52 0H6.28V12h24.25zm3.19-3.17h-1.91v-5.07h1.91z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_169",
  "data-name": "Path 169",
  className: "cls-2",
  d: "M18.55 21h-2.2a1.22 1.22 0 0 0-.37-.38v-2.94a.58.58 0 0 0-.57-.57.57.57 0 0 0-.57.57v2.91a1.11 1.11 0 0 0-.56.95 1.111 1.111 0 0 0 2.07.57h2.2a.58.58 0 0 0 .57-.57.57.57 0 0 0-.57-.54z"
});

function SvgIcnBatterychargingtime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icn-batterychargingtime",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-base",
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), _ref2, _ref3));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBatterychargingtime);
export default __webpack_public_path__ + "static/media/icn-batterychargingtime.f9494432bf362939f56ad83a211fb269.svg";
export { ForwardRef as ReactComponent };